import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abfa7a72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "efficiency" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"options-title\" data-v-abfa7a72><div class=\"title\" data-v-abfa7a72>工单效能分析</div><div class=\"select-date-time\" data-v-abfa7a72></div><div class=\"custom-date-time\" data-v-abfa7a72></div></div><div class=\"content\" data-v-abfa7a72><div class=\"line-chart\" data-v-abfa7a72><div id=\"lineChart\" data-v-abfa7a72></div></div></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

import {
  computed, reactive, ref, watch, onMounted, onUnmounted,
} from 'vue';
import Highcharts from 'highcharts';
import moment, { Moment, } from 'moment';
import { useStore, } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const chart = ref<any>({});

const statisticsEfficiency = computed(() => store.state.ticket.statisticsEfficiency);

const customDate = computed(() => store.state.ticket.customDate);
const userInfo = computed(() => store.state.login.userInfo);

store.dispatch('ticket/statisticWorkOrderAnalysis', {
  startTime: moment(customDate.value[0]).format('YYYY-MM-DD'),
  endTime: moment(customDate.value[1]).format('YYYY-MM-DD'),
  userId: userInfo.value.id,
  selectType: 1,
});

watch(customDate, (val) => {
  chart.value.title.update({
    text: `${moment(val[0]).format('YYYY年MM月DD日')}-${moment(val[1]).format('YYYY年MM月DD日')}工单效能趋势图`,
  });
  store.dispatch('ticket/statisticWorkOrderAnalysis', {
    startTime: moment(customDate.value[0]).format('YYYY-MM-DD'),
    endTime: moment(customDate.value[1]).format('YYYY-MM-DD'),
    userId: userInfo.value.id,
    selectType: 1,
  });
});

watch(statisticsEfficiency,(val) => {
  if (chart.value) {
    chart.value.series[0].update({
      data: val.map((cur:any) => [moment(cur.dateT).add(8,'hours').valueOf(),cur.num,]),
    });
  }
});

const lineOption = {
  chart: {
    zoomType: 'x',
  },
  title: {
    text: `${moment(customDate.value[0]).format('YYYY年MM月DD日')}-${moment(customDate.value[1]).format('YYYY年MM月DD日')}工单效能趋势图`,
    style: {
      color: '#1D2129',
      fontSize: '.16rem',
      fontWeight: '600',
    },
  },
  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
      day: '%m-%d',
      week: '%m-%d',
      month: '%Y-%m',
      year: '%Y',
    },
  },
  tooltip: {
    dateTimeLabelFormats: {

      /*
       * millisecond: '%H:%M:%S.%L',
       * second: '%H:%M:%S',
       * minute: '%H:%M',
       * hour: '%H:%M',
       */
      day: '%Y-%m-%d',
      week: '%m-%d',
      month: '%Y-%m',
      year: '%Y',
    },
  },
  yAxis: {
    title: {
      align: 'high',
      text: '工作量/份',
      rotation: 0,
      x: 5,
      y: -30,
      style: {
        'text-anchor': 'start',
        color: '#1D2129',
        fontSize: '.13rem',
      },
    },
  },
  legend: {
    enabled: false,
    style: {
      color: '#1D2129',
      fontSize: '.13rem',
    },
  },
  plotOptions: {
    area: {
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1,
        },
        stops: [
          [0, '#85E9FF',], [1, '#85E9FF11',],
        ],
      },
      marker: {
        radius: 2,
      },
      lineWidth: 1,
      states: {
        hover: {
          lineWidth: 1,
        },
      },
      threshold: null,
    },
  },
  credits: {
    enabled: false,
  },
  series: [
    {
      type: 'area',
      name: '工单量',
      data: [],
    },
  ],
};

const initCharts = () => {
  const container = document.getElementById('lineChart') as HTMLElement;
  const hc:any = Highcharts;

  chart.value = hc.chart(container, lineOption);
};

onMounted(() => {
  initCharts();
});

onUnmounted(() => {
  // echarts.dispose(chart);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})